import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { D as DropdownItemDisplayName } from '../displayNames-27272ef3.js';
import { a as DropdownIsMobileConsumer } from '../DropdownIsMobileContext-c2f1e868.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-12ae0974.js';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-189dc982.js';
import { S as SelectOption } from '../../SelectList/SelectOption/SelectOption-dbf8bc5e.js';
import { R as RadioButton } from '../../RadioGroup/RadioButton/RadioButton-0cb296f1.js';

const DropdownItemDesktop = withTaktFallbackId(SelectOption);
const DropdownItemMobile = withTaktFallbackId(RadioButton);
class DropdownItem extends PureComponent {
  render() {
    const {
      disabled,
      value,
      renderStart,
      renderEnd,
      renderAfter,
      children,
      selected,
      onClick,
      ...rest
    } = this.props;
    const taktFallbackId = createStormTaktId('dropdown-item');
    return /*#__PURE__*/React__default.createElement(DropdownIsMobileConsumer, null, isMobile => {
      if (isMobile) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DropdownItemMobile, _extends({}, rest, {
          taktFallbackId: taktFallbackId,
          id: value,
          value: value,
          label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderStart && renderStart(), children, renderEnd && renderEnd()),
          disabled: disabled,
          isChecked: selected,
          onChange: event => {
            if (onClick) {
              onClick(event.target.value, event);
            }
          }
        })), renderAfter === null || renderAfter === void 0 ? void 0 : renderAfter());
      }
      return /*#__PURE__*/React__default.createElement(DropdownItemDesktop, _extends({}, rest, {
        taktFallbackId: taktFallbackId,
        value: value,
        renderStart: renderStart,
        renderEnd: renderEnd,
        renderAfter: renderAfter,
        disabled: disabled,
        selected: selected,
        onClick: onClick
      }), children);
    });
  }
}
_defineProperty(DropdownItem, "displayName", DropdownItemDisplayName);
_defineProperty(DropdownItem, "propTypes", {
  /**
   * Makes the item un-selectable.
   */
  disabled: PT.bool,
  /**
   * Hides the item from the dropdown.
   */
  hidden: PT.bool,
  /**
   * Function returns additional react nodes that can be used to decorate an
   * item inline before the children are rendered.
   */
  renderStart: PT.func,
  /**
   * Function returns additional react nodes that can be used to decorate an
   * item inline after the children are rendered.
   */
  renderEnd: PT.func,
  /**
   * The value returned when the item is selected.
   */
  value: PT.any,
  // eslint-disable-line react/forbid-prop-types
  /**
   * Function returns additional react nodes that can be used to render an
   * item outside of its clickable area. ex. Tooltips
   */
  renderAfter: PT.func
});
_defineProperty(DropdownItem, "defaultProps", {
  disabled: false,
  hidden: false,
  renderStart: undefined,
  renderEnd: undefined,
  value: undefined,
  renderAfter: undefined
});

export { DropdownItem as D };
//# sourceMappingURL=DropdownItem-98c01780.js.map
